export const FETCH_FLAGS_REQUEST = 'flags/FETCH_FLAGS_REQUEST';
export const FETCH_FLAGS_SUCCESS = 'flags/FETCH_FLAGS_SUCCESS';
export const FETCH_FLAGS_FAILURE = 'flags/FETCH_FLAGS_FAILURE';
